import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core";
import {
  CardMedia,
  CardContent,
  Typography,
  Button,
  IconButton,
  CircularProgress,
  Grid,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import moment from "moment";
import Card from "components/cards/Card";
import Popconfirm from "components/confirm/Popconfirm";
import { asPrice } from "utils/text";
import { callPostApiWithAuth, callPutApiWithAuth } from "utils/api";
import { autoshipStatusText } from "config/var";
import { getSubscriptionStatusLabel } from "config/var/subscription";
import { getFrequencyLabelByValue } from "config/var/frequency";
import { getCausesData } from "config/var/cause";

export default function SubscriptionCard({
  data,
  openEdition,
  afterSuccessUpdate,
}) {
  const classes = useStyles();
  const myUser = useSelector((state) => state.auth.user);
  const [isCanceling, setIsCanceling] = useState(false);
  const [causesData, setCausesData] = useState(undefined);
  const [cancelAnchor, setCancelAnchor] = useState(false);
  const [isActivating, setIsActivating] = useState(false);
  const [activateAnchor, setActivateAnchor] = useState(false);

  const changeSubcriptionStatus = (status) => {
    if (status == 3) {
      setIsCanceling(true);
    } else if (status == 1) {
      setIsActivating(true);
    }
    callPutApiWithAuth(
      `subscriptions/${data.id}/change_status`,
      { status: status },
      onSuccessChangeSubscriptionStatus,
      onFailedChangeSubscriptionStatus
    );
  };

  const onSuccessChangeSubscriptionStatus = (data) => {
    setIsCanceling(false);
    setIsActivating(false);
    afterSuccessUpdate(data);
  };

  const onFailedChangeSubscriptionStatus = (err) => {
    setIsCanceling(false);
    setIsActivating(false);
    setIsActivating(false);
  };

  useEffect(() => {
    setCausesData(getCausesData("id", data.details[0].product_id));
  }, [data]);

  return (
    <>
      {data && causesData ? (
        <Card className={classes.subscriptionCard}>
          <Grid container spacing={3}>
            <Grid
              item
              xs={4}
              md={4}
              lg={4}
              xl={4}
              className={classes.imageGrid}
            >
              <CardMedia
                image={causesData.image}
                className={classes.subscriptionImage}
              />
              {data.status == 2 ? (
                <>
                  <Button
                    className={classes.activeButton}
                    variant="contained"
                    onClick={(e) => setActivateAnchor(true)}
                  >
                    {isActivating && (
                      <CircularProgress color={"primary"} size={24} />
                    )}
                    Active
                  </Button>
                  <Popconfirm
                    title="Activate subscription?"
                    className={classes.activateConfirmModal}
                    anchorEl={activateAnchor}
                    onConfirm={() => {
                      changeSubcriptionStatus(1);
                      setActivateAnchor(false);
                    }}
                    onCancel={() => setActivateAnchor(false)}
                  />
                </>
              ) : (
                <Button
                  className={classes.editButton}
                  variant="contained"
                  onClick={(e) => openEdition(data)}
                >
                  Edit
                </Button>
              )}
            </Grid>
            <Grid
              item
              xs={8}
              md={8}
              lg={8}
              xl={8}
              className={classes.contentGrid}
            >
              <CardContent className={classes.subscriptionDetail}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12} lg={12} xl={12}>
                    <Grid
                      container
                      spacing={3}
                      className={classes.subscriptionHeader}
                    >
                      <Grid
                        item
                        xs={1}
                        md={1}
                        lg={1}
                        xl={1}
                        className={`${classes.noPaddingBottom} ${classes.noPaddingLeft}`}
                      >
                        <img
                          className={classes.subscriptionIcon}
                          src={causesData.icon}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={10}
                        sm={10}
                        md={10}
                        lg={10}
                        xl={10}
                        className={`${classes.noPaddingBottom} ${classes.noPaddingLeft}`}
                      >
                        <Typography
                          component={"h2"}
                          className={classes.shortTitle}
                          style={{ marginLeft: 5 }}
                        >
                          {causesData.shortTitle}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        sm={1}
                        md={1}
                        lg={1}
                        xl={1}
                        className={`${classes.noPaddingTop} ${classes.noPaddingLeft} ${classes.smallDelete}`}
                      >
                        <IconButton
                          color="primary"
                          onClick={(e) => setCancelAnchor(true)}
                        >
                          {!isCanceling ? (
                            <DeleteIcon />
                          ) : (
                            <CircularProgress color={"primary"} size={24} />
                          )}
                        </IconButton>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={`${classes.noPaddingTop} ${classes.noPaddingLeft} ${classes.noPaddingBottom} ${classes.detailRow}`}
                      >
                        <Typography
                          component={"h2"}
                          className={classes.fieldName}
                        >
                          {"Date Created: "}&nbsp;&nbsp;
                        </Typography>
                        <Typography
                          component={"h2"}
                          className={classes.fieldValue}
                        >
                          {moment(data.created_at).format("MMMM DD, YYYY")}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={`${classes.noPaddingTop} ${classes.noPaddingLeft} ${classes.noPaddingBottom} ${classes.detailRow}`}
                      >
                        <Typography
                          component={"h2"}
                          className={classes.fieldName}
                        >
                          {"Amount: "}&nbsp;&nbsp;
                        </Typography>
                        <Typography
                          component={"h2"}
                          className={classes.fieldValue}
                        >
                          {data.details[0].amount
                            ? asPrice(data.details[0].amount)
                            : "-"}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={`${classes.noPaddingTop} ${classes.noPaddingLeft} ${classes.detailRow}`}
                      >
                        <Typography
                          component={"h2"}
                          className={classes.fieldName}
                        >
                          {"Total Amount: "}&nbsp;&nbsp;
                        </Typography>
                        <Typography
                          component={"h2"}
                          className={classes.fieldValue}
                        >
                          <span className={classes.totalAmount}>
                            {asPrice(data?.total_amount)}
                          </span>
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={12} lg={12} xl={12}>
                    <Grid
                      container
                      spacing={3}
                      className={classes.subscriptionContent}
                    >
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={`${classes.noPaddingLeft} ${classes.noPaddingBottom} ${classes.detailRow}`}
                      >
                        <Typography
                          component={"h2"}
                          className={classes.fieldName}
                        >
                          {"Status:"}&nbsp;&nbsp;
                        </Typography>
                        <Typography
                          component={"h2"}
                          className={classes.fieldValue}
                        >
                          <span
                            className={`${
                              classes.statusValue
                            } subscription-status-${getSubscriptionStatusLabel(
                              data.status
                            ).toLowerCase()}`}
                          >{` ${getSubscriptionStatusLabel(
                            data.status
                          ).toUpperCase()}`}</span>
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={`${classes.noPaddingLeft} ${classes.noPaddingBottom} ${classes.noPaddingTop} ${classes.detailRow}`}
                      >
                        <Typography
                          component={"h2"}
                          className={classes.fieldName}
                        >
                          {"Last Bill Date: "}&nbsp;&nbsp;
                        </Typography>
                        <Typography
                          component={"h2"}
                          className={classes.fieldValue}
                        >
                          {data.last_billing_at
                            ? moment(data.last_billing_at).format(
                                "MMMM DD, YYYY"
                              )
                            : "-"}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={`${classes.noPaddingLeft} ${classes.noPaddingBottom} ${classes.noPaddingTop} ${classes.detailRow}`}
                      >
                        <Typography
                          component={"h2"}
                          className={classes.fieldName}
                        >
                          {"Next Bill Date: "}&nbsp;&nbsp;
                        </Typography>
                        <Typography
                          component={"h2"}
                          className={classes.fieldValue}
                        >
                          {data.next_billing_at
                            ? moment(data.next_billing_at).format(
                                "MMMM DD, YYYY"
                              )
                            : "-"}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={`${classes.noPaddingLeft} ${classes.noPaddingBottom} ${classes.noPaddingTop} ${classes.detailRow}`}
                      >
                        <Typography
                          component={"h2"}
                          className={classes.fieldName}
                        >
                          {"Frequency: "}&nbsp;&nbsp;
                        </Typography>
                        <Typography
                          component={"h2"}
                          className={classes.fieldValue}
                        >
                          <span
                            className={classes.status}
                          >{` ${getFrequencyLabelByValue(data.cycle)}`}</span>
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Grid>
          </Grid>
        </Card>
      ) : (
        <></>
      )}
      <Popconfirm
        title="Cancel Subscription?"
        className={classes.cancelConfirmModal}
        anchorEl={cancelAnchor}
        onConfirm={() => {
          changeSubcriptionStatus(3);
          setCancelAnchor(false);
        }}
        onCancel={() => setCancelAnchor(false)}
      />
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  smallDelete: {
    [theme.breakpoints.down("xs")]: {
      padding: "0px !important",
      display: "flex",
      justifyContent: "flex-end",
      "& button": {
        padding: "0px !important",
      },
    },
  },
  imageGrid: {
    "@media (max-width: 500px)": {
      width: "100%",
      maxWidth: "100%",
      height: 300,
      flexBasis: "100%",
      paddingRight: "0px !important",
    },
  },
  subscriptionIcon: {
    height: 20,
  },
  contentGrid: {
    "@media (max-width: 500px)": {
      width: "100%",
      maxWidth: "100%",
      flexBasis: "100%",
    },
  },
  subscriptionImage: {
    width: "auto",
    height: "80%",
    borderRadius: 5,
  },
  editButton: {
    width: "100%",
    height: "15%",
    marginTop: 10,
    boxShadow: "unset",
    backgroundColor: `${theme.palette.primary.primaryColor} !important`,
    color: "#FFFFFF !important",
  },
  activeButton: {
    width: "100%",
    height: "15%",
    marginTop: 10,
    boxShadow: "unset",
  },
  subscriptionDetail: {
    paddingTop: 0,
    paddingLeft: 0,
    display: "flex",
    "& h2": {
      fontFamily: "Proxima Nova, sans-serif !important",
    },
  },
  subscriptionHeader: {
    borderBottom: "1px solid #DFE3E9",
    marginLeft: 0,
    marginRight: 0,
  },
  detailRow: {
    display: "flex",
  },
  shortTitle: {
    fontSize: 16,
    fontWeight: 600,
  },
  fieldName: {
    fontSize: 14,
    fontWeight: 600,
  },
  fieldValue: {
    fontSize: 14,
    color: "#6f6f6f",
  },
  statusValue: {
    fontWeight: 600,
  },
  subscriptionContent: {
    marginLeft: 0,
  },
  noPaddingTop: {
    paddingTop: "0px !important",
  },
  noPaddingBottom: {
    paddingBottom: "5px !important",
  },
  noPaddingLeft: {
    paddingLeft: "0px !important",
  },
  noPaddingRight: {
    paddingRight: "0px !important",
  },
  subscriptionCard: {
    padding: theme.spacing(3),
    "& .MuiCardContent-root": {
      padding: 0,
      paddingRight: 12,
      paddingBottom: "0px !important",
      "@media (max-width: 500px)": {},
    },
  },
  totalAmount: {
    color: `${theme.palette.primary.primaryColor} !important`,
    fontWeight: 600,
  },
  cancelConfirmModal: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "center !important",
    "& .MuiPopover-root": {
      // "@media (max-width: 960px)": {
      //   left: "calc(40% - 20px) !important",
      // },
    },
    "& .MuiPopover-paper": {
      top: "auto !important",
      left: "auto !important",
    },
    "& button": {
      width: '50%',
      boxShadow: 'unset',
      border: "unset !important",
    }
  },
  activateConfirmModal: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    "& .MuiPopover-paper": {
      top: "300px !important",
      left: "50% !important",
      "@media (max-width: 960px)": {
        left: "calc(40% - 20px) !important",
      },
    },
  },
}));
